/* Copyright 2014 The MathWorks, Inc. */

/**
 * This service provides the ability to:
 * 1. Get the preference directory path (prefdir) - It invokes "prefdir" and returns a promise that resolves to the
 * resulting path. It also caches the path after the first time it is retrieved.
 * 2. Write files to the preferences directory
 * 3. Read files from the preferences directory
 */

define([
    "mw-remote/Remote",
    "dojo/Deferred",
    "mw-filename-utils/FileNameUtil"
], function (Remote, Deferred, FileNameUtil) {

    var preferenceDirectoryPath = null;

    Remote.registerResponseHandler("FEvalResponse:GetPreferenceDirectory", function (results, context) {
        if (results.length === 1) {
            if (results[0].isError) {
                context.reject(results[0]);
            } else {
                preferenceDirectoryPath = results[0].results[0];
                context.resolve(preferenceDirectoryPath);
            }
        } else {
            var msg = "Error while getting prefdir: Expected 1 result message back, received: " + results.length;
            context.reject(msg);
        }
    }, this);

    Remote.registerFaultHandler("FEval:GetPreferenceDirectory", function (fault, context) {
        context.reject(fault);
    }, this);

    Remote.registerResponseHandler("CreateFileResponse:WriteFileToPreferenceDirectory", function (responses, context) {
        if (responses.length === 1) {
            if (responses[0].messageFaults && responses[0].messageFaults.length > 0) {
                context.reject(responses[0].messageFaults);
            } else {
                context.resolve("File Created");
            }
        } else {
            var msg = "Error while writing file to prefdir: Expected 1 result message back, received: " + responses.length;
            context.reject(msg);
        }
    }, this);

    Remote.registerFaultHandler("CreateFileResponse:WriteFileToPreferenceDirectory", function (fault, context) {
        context.reject(fault);
    }, this);

    Remote.registerResponseHandler("OpenFileResponse:ReadFileFromPreferenceDirectory", function (responses, context) {
        if (responses.length === 1) {
            if (responses[0].messageFaults && responses[0].messageFaults.length > 0) {
                context.reject(responses[0].messageFaults);
            } else {
                context.resolve(responses[0].file.content);
            }
        } else {
            var msg = "Error while reading file from prefdir: Expected 1 result message back, received: " + responses.length;
            context.reject(msg);
        }
    }, this);

    Remote.registerFaultHandler("OpenFileResponse:ReadFileFromPreferenceDirectory", function (fault, context) {
        context.reject(fault);
    }, this);

    return {
        getPreferenceDirectoryPath: function () {
            var deferred = new Deferred();

            if (preferenceDirectoryPath === null) {
                Remote.sendMessage({
                    FEval: {
                        "function": "prefdir",
                        "arguments": [],
                        "nargout": 1,
                        "priority": 1
                    }
                }, deferred, "GetPreferenceDirectory");
            } else {
                deferred.resolve(preferenceDirectoryPath);
            }

            return deferred.promise;
        },

        writeFileToPreferenceDirectory: function (fileName, content) {
            var deferred = new Deferred();

            this.getPreferenceDirectoryPath().then(function (preferenceDirectoryPath) {
                var sessionFile = FileNameUtil.createEmptyFileObject(preferenceDirectoryPath, fileName);
                sessionFile.content = content;

                Remote.sendMessage({
                    CreateFile: {
                        file: sessionFile,
                        updateIfExists: true
                    }
                }, deferred, "WriteFileToPreferenceDirectory");
            });

            return deferred.promise;
        },

        readFileFromPreferenceDirectory: function (fileName) {
            var deferred = new Deferred();

            this.getPreferenceDirectoryPath().then(function (preferenceDirectoryPath) {
                Remote.sendMessage({
                    OpenFile: {
                        path: FileNameUtil.createFilePath(preferenceDirectoryPath, fileName)
                    }
                }, deferred, "ReadFileFromPreferenceDirectory");
            });

            return deferred.promise;
        }
    };
});